class Project {
    constructor({
        image = [],
        special_status = false,
        abs = 0,
        glow = 0,
        crystal = 0,
        startDate = "",
        endDate = "",
        extraNotes = "",
        tags = [],
        timer_status = "paused",
        project_status = "ongoing",
        totalDuration = 0,
        _id = "",
        userId = "",
        artist = "",
        design = "",
        brand = "",
        canvas_width = 0,
        canvas_height = 0,
        diamond_type = "Round",
        no_of_color = 0,
        total_amount_diamonds = 0,
        price = 0.0,
        currency_code = "usd",
        created_at = 0,
        __v = 0
    }) {
        this.image = image;
        this.special_status = special_status;
        this.abs = abs;
        this.glow = glow;
        this.crystal = crystal;
        this.startDate = startDate;
        this.endDate = endDate;
        this.extraNotes = extraNotes;
        this.tags = tags;
        this.timer_status = timer_status;
        this.project_status = project_status;
        this.totalDuration = totalDuration;
        this._id = _id;
        this.userId = userId;
        this.artist = artist;
        this.design = design;
        this.brand = brand;
        this.canvas_width = canvas_width;
        this.canvas_height = canvas_height;
        this.diamond_type = diamond_type;
        this.no_of_color = no_of_color;
        this.total_amount_diamonds = total_amount_diamonds;
        this.price = price;
        this.currency_code = currency_code;
        this.created_at = created_at;
        this.__v = __v;
    }
}

class GamificationInfo {
    constructor({
        level = 0,
        level_title = "",
        level_description = "",
        tier_name = "",
        tier_key = "",
        total_xp = 0,
        current_xp = 0,
        xp_required_for_completion = 0,
        streak_days = "No streak yet",
    } = {}) {
        this.level = level;
        this.level_title = level_title;
        this.level_description = level_description;
        this.tier_name = tier_name;
        this.tier_key = tier_key;
        this.total_xp = total_xp;
        this.current_xp = current_xp;
        this.xp_required_for_completion = xp_required_for_completion;
        this.streak_days = streak_days;
    }
}

const DEFAULT_HOME_GAMIFICATION = {
    level: 0,
    level_title: "",
    level_description: "",
    tier_name: "",
    tier_key: "",
    total_xp: 0,
    current_xp: 0,
    xp_required_for_completion: 0,
    streak_days: "No streak yet",
};

class HomeModel {
    constructor({
        projectList = [],
        totalCompleted = 0,
        diamondsPlaced = 0,
        hoursLogged = 0,
        projectsNotStarted = 0,
        gamification = null,
    }) {
        this.projectList = projectList.map(project => new Project(project));
        this.totalCompleted = totalCompleted;
        this.diamondsPlaced = diamondsPlaced;
        this.hoursLogged = hoursLogged;
        this.projectsNotStarted = projectsNotStarted;
        this.gamification = new GamificationInfo(
            gamification && typeof gamification === "object"
                ? gamification
                : DEFAULT_HOME_GAMIFICATION
        );
    }
}

export { Project, HomeModel, GamificationInfo };
